<template>
  <!-- Modal -->
  <div class="modal fade"
       :id="modalId"
       tabindex="-1"
       role="dialog"
       aria-labelledby="baseModalTitle"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" :class="modalSize">
      <div class="modal-content" :class="{
          's-height' : sHeight,
          'm-height' : mHeight,
          'lg-height' : lgHeight,
          'xl-height' : xlHeight,
          'xxl-height' : xxlHeight,
        }">
        <div class="modal-header">
          <!-- this is header title -->
          <h5 class="modal-title font-weight-bold mr-3" id="baseModalTitle">{{ modalTitle }}</h5>

          <!-- this is other items in header like buttons -->
          <slot name="modal-header-others"></slot>

          <!-- this is close button -->
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="thisCloseEvent">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- this is any content in body part -->
          <slot name="modal-body"></slot>
        </div>
        <div class="modal-footer">
          <!-- this is any content on footer part -->
          <slot name="modal-footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  /** mixins **/
  mixins: [],

  /** props **/
  props: {
    modalTitle: {
      type: String,
      default: 'Sample modal title',
      required: false,
    },

    modalId: {
      type: String,
      required: true,
    },

    modalSize: {
      type: String,
      default: 'sm',
    },

    sHeight: {
      type: Boolean,
      default: false,
    },

    mHeight: {
      type: Boolean,
      default: false,
    },

    lgHeight: {
      type: Boolean,
      default: false,
    },

    xlHeight: {
      type: Boolean,
      default: false,
    },

    xxlHeight: {
      type: Boolean,
      default: false,
    },
  },

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {
    thisCloseEvent(){
      this.$emit('closingEvent','Hellow');
    }
  },

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {

  },
};
</script>

<!-- todo add height css -->
<style scoped lang="scss">


.sm {
  max-width: 500px;
}

.md {
  max-width: 750px;
}

.lg {
  max-width: 960px;
}

.xl {
  max-width: 1200px;
}
.xxl {
  max-width: 1400px;
}


.s-height {
  height: 250px !important;
}

.m-height {
  max-height: 500px !important;
}

.lg-height {
  height: 550px !important;
}

.xl-height {
  height: 750px !important;
}

.xxl-height {
  height: 920px !important;
}
</style>
